document.addEventListener("DOMContentLoaded", () => {
  const accessibilityLink = document.querySelector(
    'a[href="/pages/accessibility"]'
  );

  if (accessibilityLink) {
    const newElement = document.createElement("li");
    newElement.className = "accessibility-helper";
    newElement.innerHTML = `
        <button onclick="window.interdeal.a11y.openMenu()" class="link link--text list-menu__item list-menu__item--link uppercase" style="text-align:left;">
         Enable Accessibility Options
        </button>
      `;

    accessibilityLink.parentElement.insertAdjacentElement(
      "afterend",
      newElement
    );
  }

  // accessibility fix for owl slide( empty buttons )
  const MAX_RETRIES = 10;
  let retryCount = 0;

  const addAriaLabel = (elemSelector = ".owl-dots") => {
    console.log("setting aria labels");
    const owlContainers = document.querySelectorAll(elemSelector); // Select all owl-dots containers

    if (owlContainers.length > 0) {
      owlContainers.forEach((container) => {
        const owlDots = container.querySelectorAll(".owl-dot"); // Get all dots in the current container
        if (owlDots.length > 0) {
          owlDots.forEach((dot, index) => {
            dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
          });
        }
      });
      owlContainers.forEach(el => {
        el.setAttribute('tabindex', '0');
      });
    } else if (retryCount < MAX_RETRIES) {
      retryCount++;
      setTimeout(addAriaLabel, 500);
    }
  };

  addAriaLabel();
  document.addEventListener("AddAriaLabelsToOwl", (e) =>
    addAriaLabel(e.detail.element)
  );

  const menuItems = document.querySelectorAll('a[href="#"].list-menu__item');
  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        const mouseoverEvent = new Event("mouseover", {
          bubbles: true,
          cancelable: true,
        });
        menuItem.dispatchEvent(mouseoverEvent);

        setTimeout(() => {
          const visibleMegamenu = document.querySelector(
            ".megamenu--isVisible"
          );
          if (visibleMegamenu) {
            const focusableElements = visibleMegamenu.querySelectorAll(
              'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            if (focusableElements.length > 0) {
              focusableElements[0].focus();

              focusableElements[focusableElements.length - 1].addEventListener(
                "keydown",
                (e) => {
                  if (e.key === "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    document
                      .querySelector(".megamenu--current")
                      .parentNode.nextElementSibling.querySelector("a")
                      .focus();
                  }
                }
              );

              focusableElements[0].addEventListener("keydown", (e) => {
                if (e.key === "Tab" && e.shiftKey) {
                  e.preventDefault();
                  focusableElements[focusableElements.length - 1].focus();
                }
              });
            }
          }
        }, 1000);
      }
    });
  });

  // mega menu
  document.querySelectorAll('.custom-mega-menu').forEach(menu => {
    const summary = menu.querySelector('summary');
    const headerMenu = menu.closest('header-menu');
    let closeTimeout;
  
    menu.addEventListener('toggle', () => {
      const expanded = menu.open ? 'true' : 'false';
      summary.setAttribute('aria-expanded', expanded);
      headerMenu?.setAttribute('aria-expanded', expanded);
    });
  
    summary.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      menu.open = true;
      summary.setAttribute('aria-expanded', 'true');
      headerMenu?.setAttribute('aria-expanded', 'true');
    });
  
    menu.addEventListener('mouseleave', () => { 
      closeTimeout = setTimeout(() => {
        menu.open = false;
        summary.setAttribute('aria-expanded', 'false');
        headerMenu?.setAttribute('aria-expanded', 'false');
      }, 250);  
    });
  
    menu.addEventListener('mouseenter', () => {  
      clearTimeout(closeTimeout);
    });
  });
  
  
  //   improve annoucement bar links accessibility
  const menuLinks = document.querySelectorAll(
    ".announcement-bar__menu-link[aria-controls]"
  );

  menuLinks.forEach(link => {
    const dropdownId = link.getAttribute('aria-controls');
    const dropdown = document.getElementById(dropdownId);
   
    link.addEventListener('mouseenter', e => {
      e.preventDefault();
   
      document.querySelectorAll('.announcement-bar__menu-link[aria-expanded="true"]').forEach(openLink => {
        openLink.setAttribute('aria-expanded', 'false');
        const openDropdown = document.getElementById(openLink.getAttribute('aria-controls'));
        if (openDropdown) openDropdown.hidden = true;
      });
  
      link.setAttribute('aria-expanded', 'true');
      if (dropdown) dropdown.hidden = false;
    });
   
    [link, dropdown].forEach(el => {
      if (!el) return;
  
      el.addEventListener('mouseleave', () => {
        setTimeout(() => {
          const linkHovered = link.matches(':hover');
          const dropdownHovered = dropdown && dropdown.matches(':hover');
  
          if (!linkHovered && !dropdownHovered) {
            link.setAttribute('aria-expanded', 'false');
            if (dropdown) dropdown.hidden = true;
          }
        }, 100);
      });
    });
  });
  // yotpo yotpo-pictures-gallery-images-wrapper
  function enhanceYotpoOverlays() {
    const overlays = document.querySelectorAll(
      '.yotpo-pictures-gallery-images-wrapper .y-image-overlay'
    );
  
    overlays.forEach(overlay => {
      if (overlay.dataset.enhanced) return;  
      overlay.dataset.enhanced = true;
  
      overlay.setAttribute('role', 'button');
      overlay.setAttribute('tabindex', '-1');  
      if (!overlay.hasAttribute('aria-label')) {
        overlay.setAttribute('aria-label', 'Open image');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', enhanceYotpoOverlays);
  const observer = new MutationObserver(() => enhanceYotpoOverlays());
  observer.observe(document.body, { childList: true, subtree: true });

});
